import $http from '@/api';

export default {
  addInternalTag: (contentId, tagId) => $http.post(`/api/content/${contentId}/internalTag/add`, { id: tagId }),
  removeInternalTag: (contentId, tagId) => $http.post(`/api/content/${contentId}/internalTag/remove`, { id: tagId }),
  cancelScheduledPublication: contentId => $http.post(`/api/content/${contentId}/scheduled-publication/cancel`),
  cancelScheduledUnpublication: contentId => $http.post(`/api/content/${contentId}/scheduled-unpublication/cancel`),
  searchForUnpublishedContents: (type, id, relativeVersionId, quillData) => $http.post(`/api/content/quill-js/unpublished_contents/${type}/${id}/${relativeVersionId}`, { quillData }),
};
